<template>
    <v-dialog v-model="shows" max-width="724" width="100%" content-class="rounded-lg" eager>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>

        <v-sheet class="fill-height">
            <v-layout column fill-height>
                <bottom-sheet-header style="position: relative">
                    포인트 충전하기
                    <v-btn small text fab tile absolute right color="white" @click="shows = false"> <v-icon>mdi-close</v-icon> </v-btn>
                </bottom-sheet-header>
                <div class="scroll-primary" style="flex: 1 1 auto; overflow-y: auto">
                    <v-sheet class="pa-40 pa-lg-60">
                        <div class="d-flex align-center mb-8 mb-lg-16" style="position: relative">
                            <h5 class="page-text--lg line-height-15">
                                충전하실 금액을 선택해주세요
                                <span class="page-text--sm grey-6--text pl-8 font-weight-regular">(보유포인트: {{ user?.point?.format() || 0 }}P)</span>
                            </h5>
                        </div>
                        <v-divider class="primary border-2" />
                        <vertical-table-row term="충전금액">
                            <v-combobox v-model="order.paymentAmount" :items="paymentAmounts" dense outlined hide-details>
                                <template v-slot:selection="{ item }">
                                    <i class="icon icon-point mr-4"></i>
                                    <span>{{ parseInt(item).format() }}</span>
                                </template>
                                <template v-slot:item="{ item }">
                                    <v-icon color="grey" left>mdi-alpha-p-circle</v-icon>
                                    <span>{{ parseInt(item).format() }}</span>
                                </template>
                            </v-combobox>
                        </vertical-table-row>
                        <div class="v-btn-group">
                            <v-btn outlined color="grey-d" @click="charge" class="min-w-140px min-w-lg-160px"><span class="grey-6--text">신용카드 결제</span></v-btn>
                            <point-form-account :amount="order.paymentAmount" @processed="shows = false">
                                <template #activator="{ attrs, on }">
                                    <v-btn v-bind="attrs" v-on="on" color="primary" class="min-w-140px min-w-lg-160px"><span>무통장 입금</span></v-btn>
                                </template>
                            </point-form-account>
                        </div>
                        <!-- <v-card-actions class="justify-center mt-30">
                            <v-btn outlined color="grey lighten-4" @click="charge">
                                <span class="black--text"> 신용카드 결제 </span>
                            </v-btn>
                            <point-form-account :amount="order.paymentAmount" @processed="shows = false">
                                <template #activator="{ attrs, on }">
                                    <v-btn color="primary" class="ml-16" v-bind="attrs" v-on="on"> 무통장 입금 </v-btn>
                                </template>
                            </point-form-account>
                        </v-card-actions> -->
                    </v-sheet>
                </div>
            </v-layout>
        </v-sheet>
        <nice-pay ref="nicepay" v-on="{ complete }" />
    </v-dialog>
</template>

<script>
import api from "@/api";
import { mapActions, mapState } from "vuex";

import NicePay from "@/components/plugins/nicepayments/nice-pay.vue";
import PointFormAccount from "./point-form-account.vue";
import VerticalTableRow from "@/components/dumb/vertical-table-row.vue";
import BottomSheetHeader from "@/components/dumb/bottom-sheet-header.vue";

const paymentAmounts = [1000, 3000, 5000, 10000, 30000, 50000];

export default {
    components: {
        NicePay,
        PointFormAccount,
        VerticalTableRow,
        BottomSheetHeader,
    },
    data: () => ({
        order: {
            orderName: "포인트 구매",
            paymentAmount: 10000,
            paymentMethod: "card",
            paymentGateway: "nicepay",
        },

        shows: false,
        paymentAmounts,
    }),
    computed: {
        ...mapState(["user"]),
    },
    mounted() {
        this.getUser();
    },
    watch: {
        shows() {
            if (this.shows) this.getUser();
        },
    },
    methods: {
        ...mapActions(["getUser"]),
        async charge() {
            try {
                if (this.order.paymentAmount < 1000) throw new Error("최소 충전금액은 1,000원 입니다.");
            } catch (error) {
                alert(error.message);
                return;
            }
            // 1. 주문서를 등록합니다. (주문명칭, 결제금액 등)
            let { order } = await api.v1.me.points.orders.post({
                ...this.order,
                orderName: `${this.order.paymentAmount.format()} 포인트 구매`,
            });

            // 2. 결제대행사(PG업체)에 주문정보를 전달합니다.
            this.$refs.nicepay.collection = "user-point-orders";
            this.$refs.nicepay.orderNo = order.orderNo;
            this.$refs.nicepay.orderName = order.orderName;
            this.$refs.nicepay.paymentMethod = order.paymentMethod;
            this.$refs.nicepay.paymentGateway = order.paymentGateway;
            this.$refs.nicepay.paymentAmount = order.paymentAmount;
            this.$refs.nicepay.buyerName = order.buyer.name;
            this.$refs.nicepay.buyerPhone = order.buyer.phone;
            this.$refs.nicepay.buyerEmail = order.buyer.email;

            // 3. 결제창 호출
            this.$refs.nicepay.pay();
        },
        async complete(payload) {
            // 결제대행사로부터 결제결과 메세지를 사용자에게 보여줍니다.
            alert(`[${payload?.resCode}] ${payload?.resMessage}`);

            // 사용자 보유포인트(프로필) 갱신
            await this.getUser();

            this.$emit("search");
            this.shows = false;
        },
    },
};
</script>